import middlewareHookConnector from 'utils/middlewareHookConnector';
import { useEffect } from 'react';

export function useMiddleware(actionType: string, callback: Function) {
  useEffect(
    () => middlewareHookConnector.subscribe(actionType, callback),
    []
  );
}
